<template>
  <v-app
    style="
    background: #E6EBEB;
  "
  >
    <div class="opaciter">
      <div class="app-container">
        <router-view></router-view>
      </div>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ campaign: 'getCurrentCampaign' })
  },
  data() {
    return {
      title: '○○アプリ'
    };
  }
};
</script>

<style lang="stylus">
colorGreenOk = #6cc644

.opaciter
  background-color:	'#C6C6C6';
.app-container

.v-btn
  text-transform: none !important
hr.app-hr
  margin: 20px 0
  border-top: 1px solid #dce4ec
</style>
